import { apiService } from "@/shared/services/api";
import type {
  EmailInvitationListResponse,
  EmailInvitationStats,
  EmailInvitationFilters,
} from "../types/email-invitation.types";

class EmailInvitationService {
  /**
   * Get email invitations for the authenticated user
   */
  async getMyInvitations(
    filters?: EmailInvitationFilters
  ): Promise<{ success: boolean; data: EmailInvitationListResponse }> {
    const params = new URLSearchParams();
    if (filters?.status) params.append("status", filters.status);
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.limit) params.append("limit", filters.limit.toString());

    const response = await apiService.get<{ success: boolean; data: EmailInvitationListResponse }>(
      `/email-invitations/my-invitations?${params.toString()}`
    );
    return response.data;
  }

  /**
   * Get invitation statistics for the authenticated user
   */
  async getMyStats(): Promise<{ success: boolean; data: EmailInvitationStats }> {
    const response = await apiService.get<{ success: boolean; data: EmailInvitationStats }>(
      "/email-invitations/my-stats"
    );
    return response.data;
  }

  /**
   * Get all invitations for the organization (FMO/HR access)
   */
  async getOrganizationInvitations(
    filters?: EmailInvitationFilters & { referrerId?: string }
  ): Promise<{ success: boolean; data: any }> {
    const params = new URLSearchParams();
    if (filters?.status) params.append("status", filters.status);
    if (filters?.referrerId) params.append("referrerId", filters.referrerId);
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.limit) params.append("limit", filters.limit.toString());

    const response = await apiService.get<{ success: boolean; data: any }>(
      `/email-invitations/organization/invitations?${params.toString()}`
    );
    return response.data;
  }

  /**
   * Get organization-wide invitation statistics
   */
  async getOrganizationStats(): Promise<{ success: boolean; data: EmailInvitationStats }> {
    const response = await apiService.get<{ success: boolean; data: EmailInvitationStats }>(
      "/email-invitations/organization/stats"
    );
    return response.data;
  }

  /**
   * Get top referrers in the organization
   */
  async getTopReferrers(limit: number = 10): Promise<{ success: boolean; data: any[] }> {
    const response = await apiService.get<{ success: boolean; data: any[] }>(
      `/email-invitations/organization/top-referrers?limit=${limit}`
    );
    return response.data;
  }
}

export default new EmailInvitationService();
